<div style="padding:10px;">
  <span class="section-header">
    Add/Edit News Item
  </span>
  <div class="row-no-margin form-group">
    <div class="col-md-3">
      <label for="newsTitle" class="col-form-label">Title</label>
    </div>
    <div class="col-md-6">
      <input id="newsTitle" type="text" (blur)="InputValidate()" [(ngModel)]="NewNewsItem.Title" />
    </div>

  </div>
  <div class="row-no-margin form-group">
    <div class="col-md-3">
      <label for="newsDesc" class="col-form-label">Description</label>
    </div>
    <div class="col-md-9">
      <input id="newsDesc" style="width:100%;" (blur)="InputValidate()" type="text" [(ngModel)]="NewNewsItem.Description" />
    </div>

  </div>
  <div class="row-no-margin form-group">
    <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
      <mat-label>Type</mat-label>
      <!--<label for="fileType" class="col-form-label">Type</label>-->
      <mat-select id="fileType" [(value)]="NewNewsItem.Type">
        <mat-option value="directlink">
          Link to External Site
        </mat-option>
        <mat-option value="infocenterfile">
          Info Center File
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!--<div class="col-md-3">
      <label for="newsLink" class="col-form-label">Link Type</label>
    </div>
    <div class="col-md-9">
      <input id="newsLink" type="text" style="width:100%;" (blur)="InputValidate()" [(ngModel)]="NewNewsItem.Type" />
    </div>-->

  </div>
  <div [hidden]="NewNewsItem.Type != 'directlink'" class="row-no-margin form-group">
    <div class="col-md-3">
      <label for="newsLink" class="col-form-label">Link to Article</label>
    </div>
    <div class="col-md-9">
      <input id="newsLink" type="text" style="width:100%;" (blur)="InputValidate()" [(ngModel)]="NewNewsItem.Link" />
    </div>

  </div>
  <div [hidden]="NewNewsItem.Type != 'infocenterfile'" class="row-no-margin form-group">
    <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
      <mat-label>Info Center File</mat-label>
      <!--<label for="fileType" class="col-form-label">Type</label>-->
      <mat-select id="infocenterFile" [(value)]="NewNewsItem.InfoCenterFileID">
        <mat-option *ngFor="let file of InfoCenterFiles" [value]="file.InfoCenterFileID">
          {{file.FileName}}
        </mat-option>
        
      </mat-select>
    </mat-form-field>

  </div>
  <!--<div class="row-no-margin form-group">
    <div class="col-md-3">
      <label class="col-form-label">Thumbnail</label>
    </div>
    <div class="col-md-6">
      <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload />
      <div class="file-upload" style="padding: 10px 0px;">
        {{NewNewsItem.ImagePath || "No file uploaded yet."}}
        <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUpload.click()">
          <mat-icon>attach_file</mat-icon>
        </button>
      </div>
    </div>

  </div>-->

</div>
